import { render, staticRenderFns } from "./posSeatLayout.vue?vue&type=template&id=53c7eebb"
import script from "./posSeatLayout.vue?vue&type=script&lang=js"
export * from "./posSeatLayout.vue?vue&type=script&lang=js"
import style0 from "./posSeatLayout.vue?vue&type=style&index=0&id=53c7eebb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports